import { Box, Button, MultiSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { slimCardItems } from "designSystemLegacy/data";

export default () => {
	const selectActions = [
		<Button
			design="link"
			onClick={() => console.log("GoToDialog action")}
			res="GoToDialog"
		/>,
	];

	slimCardItems[1].invalid = true;
	const values = [slimCardItems[0], slimCardItems[1]];

	return (
		<CssColumnGrid columns={1}>
			<Box width={200}>
				<Text semiBold text="SlimCard" />
				<MultiSelect
					// remove input's clear selection bubble
					disableClearable
					// show groups
					grouped
					// don't show selected items chips in input control
					noChips
					options={slimCardItems}
					// add action to drop down
					selectActions={selectActions}
					// use slim card options rendering
					slimCard
					// add SUGGESTED tag
					suggestedGroups={["CA"]}
					value={values}
				/>
			</Box>
		</CssColumnGrid>
	);
};